import { ApiVersion as M } from "./types.es.js";
import { ApiErrorType as Qt, ImprHeaders as Xt, OFFLINE_STATUS_CODES as qt, SERVER_ERROR_STATUS_CODE as te, TERMINATE_REASON_CODE as ee, TracingSolutionType as re, isApiError as ne, isApiErrorLike as oe } from "./types.es.js";
import { jsonToBase64 as F } from "@imprivata-cloud/dataprivacy";
import { trace as m, context as S, SpanStatusCode as I, propagation as A } from "@opentelemetry/api";
import { Resource as y } from "@opentelemetry/resources";
import { ATTR_SERVICE_NAME as B } from "@opentelemetry/semantic-conventions";
import { WebTracerProvider as H } from "@opentelemetry/sdk-trace-web";
import { ZipkinExporter as k } from "@opentelemetry/exporter-zipkin";
import { OTLPTraceExporter as W } from "@opentelemetry/exporter-trace-otlp-http";
import { ZoneContextManager as Z } from "@opentelemetry/context-zone";
import { BatchSpanProcessor as j, SimpleSpanProcessor as z } from "@opentelemetry/sdk-trace-base";
import { registerInstrumentations as K } from "@opentelemetry/instrumentation";
import { FetchInstrumentation as Y } from "@opentelemetry/instrumentation-fetch";
import { XMLHttpRequestInstrumentation as J } from "@opentelemetry/instrumentation-xml-http-request";
import { W3CTraceContextPropagator as Q } from "@opentelemetry/core";
import { useRef as b, useEffect as D } from "react";
const X = "http://localhost:1080";
function G() {
  const t = window.location.host;
  let e, r, n, o;
  if (t != null && t.includes("localhost"))
    e = X, n = "https://metadata.app.dev.imprivata.cloud", o = "", r = "";
  else {
    const i = q(t, {
      apiUrl: { sub: "astra.sys" },
      ussUrl: { sub: "user.app", path: "/login" },
      tracingUrl: { sub: "astra.sys", path: "/v1/traces" },
      metadataUrl: { sub: "metadata.app" }
    }, "https://");
    e = i.apiUrl, o = i.tracingUrl, r = i.ussUrl, n = i.metadataUrl;
  }
  return { apiUrl: e, ussUrl: r, tracingUrl: o, metadataUrl: n };
}
const q = (t, e, r, n) => {
  const c = n || /^(?:https?\:\/\/)?([A-Za-z0-9_\-]+\.[A-Za-z0-9_])\w+/;
  return Object.entries(e).reduce(
    (i, [l, { sub: d, path: u }]) => {
      const p = t == null ? void 0 : t.replace(c, d);
      return i[l] = `${r || ""}${p}${u || ""}`, i;
    },
    {}
  );
}, bt = () => G(), tt = { BASE_URL: "/", DEV: !1, IMPR_INCLUDE_ENV_CONFIG: "true", MODE: "production", PROD: !0, SSR: !1 }, w = {
  AUTHN_API_VERSION: "authnApiVersion"
  // for testing
};
let U;
const { apiUrl: P, ussUrl: et, tracingUrl: rt, metadataUrl: v } = G();
function R(t, e, r, n) {
  const o = `IMPR_${r}`;
  return t._appConfig !== void 0 && Object.prototype.hasOwnProperty.call(t._appConfig, r) ? t._appConfig[r] : Object.prototype.hasOwnProperty.call(e, o) || Object.prototype.hasOwnProperty.call(e, r) ? e[o] ?? e[r] : n;
}
function nt(t, e) {
  let r;
  const n = new URLSearchParams(t.location.search);
  return n.has(w.AUTHN_API_VERSION) ? r = n.get(
    w.AUTHN_API_VERSION
  ) : r = R(
    t,
    e,
    "API_VERSION",
    M.V3
  ), {
    API_URL: P || R(t, e, "API_URL", P) || "",
    USER_SELF_SERVICE_URL: et || R(t, e, "SELF_SERVICE_URL", "http://localhost:3001"),
    METADATA_URL: v || R(t, e, "METADATA_URL", v) || "",
    AUTHN_API_VERSION: r,
    ZIPKIN_TRACING_URL: R(t, e, "ZIPKIN_TRACING_URL"),
    OTLP_TRACING_URL: R(
      t,
      e,
      "OTLP_TRACING_URL",
      rt
    ),
    COLLECT_TRACING: R(t, e, "COLLECT_TRACING"),
    TEST_UTILITY_ENABLED: R(t, e, "TEST_UTILITY_ENABLED"),
    LOGGING_FOR_AGENT_ENABLED: R(
      t,
      e,
      "LOGGING_FOR_AGENT_ENABLED"
    ),
    STRINGIFY_DEBUG_LOGS: R(t, e, "STRINGIFY_DEBUG_LOGS")
  };
}
function ot(t) {
  return U === void 0 && (U = nt(window, t || tt || {})), U;
}
function st(t = "") {
  const e = new URL(t);
  return e.pathname + e.search;
}
const { LOGGING_FOR_AGENT_ENABLED: at } = ot(), it = at !== "false", ct = process.env.NODE_ENV === "test" || !1, g = (t) => {
  if (!t)
    return "";
  if (typeof t == "string")
    return t;
  try {
    return JSON.stringify(t);
  } catch {
    try {
      if (typeof t == "object")
        return JSON.stringify(
          Object.entries(t).reduce(
            (r, [n, o]) => ({
              [n]: g(o)
            }),
            {}
          )
        );
      if (Array.isArray(t))
        return JSON.stringify(t.map(g));
    } catch {
    }
  }
  return `${t}`;
};
function T(...t) {
  if (it && !ct) {
    const e = new Date(Date.now()).toISOString(), r = t.map((n) => g(n));
    console.log(`[${e}]:`, ...r);
  }
}
function ut(...t) {
  const e = new Date(Date.now()).toISOString(), r = t.map((n) => g(n));
  console.debug(`[${e}]:`, ...r);
}
function Dt(...t) {
  const e = new Date(Date.now()).toISOString(), r = t.map((n) => g(n));
  console.info(`[${e}]:`, ...r);
}
function Gt(...t) {
  const e = new Date(Date.now()).toISOString(), r = t.map((n) => g(n));
  console.error(`[${e}]:`, ...r);
}
function ft(t) {
  T(`REQUEST method=${t.method} url=${t.url}`);
}
function pt(t) {
  const { status: e, statusText: r, config: n, data: o } = t, { url: c, method: i } = n;
  if (!!(o != null && o.error)) {
    const d = JSON.stringify(o.error), u = g(o);
    T(
      `(!) RESPONSE ERROR status=${e} info=${r} error=${d} method=${i} url=${c} (data=${u})`
    );
  } else
    T(
      `RESPONSE status=${e} info=${r} method=${i} url=${st(c)}`
    );
}
function lt(t) {
  const { status: e, errorText: r, method: n, url: o, dataText: c } = dt(t);
  T(
    `(!) HTTP RESPONSE ERROR status=${e} error=${r} method=${n} url=${o} (data=${c})`
  );
}
const xt = {
  request: ft,
  response: pt,
  error: lt,
  log: T,
  debug: ut
}, dt = (t) => {
  const { code: e, message: r, response: n } = t, {
    url: o,
    method: c,
    headers: i,
    data: l
  } = (t == null ? void 0 : t.config) || {};
  let d = 0, u, p, a, s;
  return n ? (d = n.status, u = n.data, p = u == null ? void 0 : u.error, a = `${(u == null ? void 0 : u.error) || "unknown"}`, s = g(u)) : (a = g({ code: e, message: r, headers: i }) || "unknown", s = l && g(l) || "unknown"), {
    status: d,
    code: e,
    message: r,
    headers: i,
    errorText: a,
    errorData: p,
    responseData: u,
    method: c,
    url: o,
    dataText: s
  };
};
function Vt(t) {
  const e = {};
  return Object.entries(t).forEach(([r, n]) => {
    e[r] = F(n);
  }), e;
}
const C = (t, e) => {
  if (!t && !e)
    return !0;
  if (!t || !e)
    return !1;
}, Et = (t, e) => !t && !e ? !0 : !t || !e ? !1 : t === e || Object.entries(t || {}).reduce((r, [n, o]) => r && n in e && e[n] === o, !0), gt = (t, e) => !t && !e ? !0 : !t || !e ? !1 : (t || []).length === (e || []).length && (t || []).every((r) => (e || []).includes(r)), Mt = (t, e) => {
  const r = C(t, e);
  return r !== void 0 ? r : Object.keys(t).every((n) => {
    const o = t[n], c = e[n], i = C(o, c);
    if (i !== void 0)
      return i;
    if (o && c && typeof o == "object" && typeof c == "object")
      return Et(o, c);
    if (Array.isArray(o) && Array.isArray(c))
      return gt(o, c);
    t[n], e[n];
  });
};
var x = /* @__PURE__ */ ((t) => (t.SERVICE = "service", t.UI = "ui", t.API = "api", t.FORM = "form", t.DATA = "data", t.AUTH = "auth", t.EFFECT = "effect", t.USER = "user", t.VIDEO = "video", t))(x || {});
const h = (t) => {
  if (!t)
    return {};
  if (typeof t == "string")
    return { attrs: t };
  if (Array.isArray(t))
    return t.reduce((r, n) => Object.assign({}, r, h(n)), {});
  if (typeof t == "object")
    return Object.entries(t).reduce(
      (r, [n, o]) => (r[n] = g(o), r),
      {}
    );
  const e = `${t}`;
  return { [e]: e };
};
function N() {
  return m.getTracer("");
}
function _t(t, e, r) {
  const n = [t, e];
  return r && n.push(r), n.join(":");
}
function Rt(t, e, r) {
  let n = {}, o, c = t;
  if (typeof e == "function")
    o = e, t || (c = o.name || "anonymous_function");
  else {
    const { attributes: l, ...d } = e || {}, u = h(l);
    n = { ...d, attributes: u }, o = r;
  }
  const i = N();
  return (...l) => {
    const d = m.getActiveSpan();
    n.attributes || (n.attributes = {}), d && (n.attributes["parent.span.id"] = d.spanContext().spanId);
    function u(p) {
      try {
        const a = m.setSpan(S.active(), p);
        return S.with(a, () => {
          const s = o(...l);
          if (s instanceof Promise)
            return s.then((f) => S.with(a, () => (p.end(), f))).catch((f) => S.with(a, () => {
              throw p.recordException(f instanceof Error ? f : new Error(String(f))), p.setStatus({ code: I.ERROR }), p.end(), f;
            }));
          if (typeof s == "function") {
            const f = s;
            return function() {
              return S.with(a, () => {
                try {
                  return f();
                } finally {
                  p.end();
                }
              });
            };
          }
          return p.end(), s;
        });
      } catch (a) {
        throw p.recordException(a instanceof Error ? a : new Error(String(a))), p.setStatus({ code: I.ERROR }), p.end(), a;
      }
    }
    return i.startActiveSpan(c, n, u);
  };
}
function $() {
  return m.getSpan(S.active());
}
function Ft(t) {
  const e = m.getActiveSpan();
  if (e)
    return e.setAttributes(t), e;
  e || mt("span-attributes", {
    _warning: "No active span. `addSpanAttributes` is should be used when there is an active span",
    _stack: new Error().stack,
    ...t
  }).end();
}
function Bt(t, e) {
  let r = $();
  if (!r) {
    const n = `${t}`;
    console.debug(`No active span found, creating new span: ${n}`), r = N().startSpan(n);
  }
  return r.addEvent(t, e), $() || r.end(), r;
}
function mt(t, e, r) {
  return N().startSpan(t, {
    ...r,
    attributes: e ? h(e) : void 0
  });
}
function Ht(t) {
  const e = m.getActiveSpan();
  if (e)
    return e.recordException(t), e.setStatus({ code: I.ERROR }), e;
}
function kt(t, e, r) {
  const n = _t(x.SERVICE, t), { exclude: o = [], ...c } = r || {}, i = { ...e };
  for (const [l, d] of Object.entries(e))
    if (!o.includes(l) && typeof d == "function") {
      const u = `${n}:${l}`, p = d.bind(i);
      i[l] = Rt(u, c, p);
    }
  return i;
}
const O = "impr.platform.context.workflow_id";
function Wt(t) {
  const {
    serviceName: e,
    propagateTraceHeaderCorsUrls: r,
    ignoreUrls: n,
    ZIPKIN_TRACING_URL: o,
    OTLP_TRACING_URL: c
  } = t;
  let i = t.workflowId;
  const l = [];
  l.push(
    new class {
      onStart(a, s) {
        var _;
        const f = A.getBaggage(s), E = (_ = f == null ? void 0 : f.getEntry(O)) == null ? void 0 : _.value;
        a.setAttribute(O, E || i);
      }
      onEnd(a) {
      }
      async shutdown() {
      }
      async forceFlush() {
      }
    }()
  ), o && l.push(
    new j(new k({ url: o }))
  ), c && l.push(
    new z(new W({ url: c }))
  );
  const d = new H({
    resource: y.default().merge(
      new y({
        [B]: e
      })
    ),
    spanProcessors: l
  });
  d.register({
    // provides a way to manage tracing context across async operations
    // for example, if the timeout or promise is initialized in one context
    // it's resolution/callbeck will be executed in that same context
    contextManager: new Z(),
    // registers a propagation mechanism that forms an http header that is later added to the requests
    // so that one trace can include spans from UI and BE
    propagator: new Q()
  }), K({
    instrumentations: [
      // automatically creates spans for fetch requests
      // also, add's a header from "propagator" to connect UI and BE traces
      new Y({
        measureRequestSize: !0,
        propagateTraceHeaderCorsUrls: r,
        ignoreUrls: n,
        applyCustomAttributesOnSpan: (a, s, f) => {
          try {
            let E, _;
            if (s instanceof Request)
              E = new URL(s.url), _ = s.method;
            else {
              const L = f == null ? void 0 : f.url;
              if (L)
                E = new URL(L);
              else
                return;
              _ = (s == null ? void 0 : s.method) || "";
            }
            const V = E.pathname;
            a.updateName(`HTTP ${_} ${V}`);
          } catch {
          }
        }
      }),
      // automatically creates spans for XMLHttpRequestInstrumentation (thus - for axios) requests
      // also, add's a header from "propagator" to connect UI and BE traces
      new J({
        measureRequestSize: !0,
        propagateTraceHeaderCorsUrls: r,
        ignoreUrls: n,
        applyCustomAttributesOnSpan: (a, s) => {
          try {
            const E = new URL(s.responseURL || "").pathname, _ = s._method || "";
            a.updateName(`HTTP ${_} ${E}`);
          } catch {
          }
        }
      })
    ]
  }), m.setGlobalTracerProvider(d);
  function u(a) {
    i = a;
    const s = { value: a }, f = S.active();
    let E = A.getBaggage(f);
    E || (E = A.createBaggage()), E = E.setEntry(O, s);
    const _ = A.setBaggage(f, E);
    S.with(_, () => {
    });
  }
  function p() {
    const a = A.getBaggage(S.active()), s = a == null ? void 0 : a.getEntry(O);
    return (s == null ? void 0 : s.value) || i;
  }
  return typeof window < "u" && window.addEventListener("error", (a) => {
    const s = m.getActiveSpan();
    s && (s.recordException(a.error), s.setStatus({ code: I.ERROR }));
  }), u(i), {
    serviceName: e,
    getTracer: () => m.getTracerProvider().getTracer(""),
    getProvider: () => m.getTracerProvider(),
    getWorkflowId: p,
    updateWorkflowId: u
  };
}
const Zt = () => {
  const t = b(!1);
  return D(() => () => {
    t.current = !0;
  }, []), t;
};
function jt() {
  const t = b(null);
  return D(() => {
    const e = () => {
      t != null && t.current && "focus" in t.current && t.current.focus();
    };
    return window.addEventListener("focus", e), () => {
      window.removeEventListener("focus", e);
    };
  }, []), t;
}
window && typeof window > "u" && (global.window = {});
const zt = "0.3.15", Kt = "1751043626131";
export {
  Qt as ApiErrorType,
  M as ApiVersion,
  zt as COMMON_MODULE_APP_VERSION,
  Kt as COMMON_MODULE_BUILD_VERSION,
  Xt as ImprHeaders,
  xt as Logger,
  X as MOCKSERVER_DEFAULT_URL,
  qt as OFFLINE_STATUS_CODES,
  te as SERVER_ERROR_STATUS_CODE,
  x as SpanComponent,
  ee as TERMINATE_REASON_CODE,
  re as TracingSolutionType,
  G as _getEnv,
  R as _getEnvVariable,
  bt as _getUrls,
  nt as _initAppConfig,
  Ft as addSpanAttributes,
  Bt as addSpanEvent,
  gt as compareArrays,
  Et as compareObjects,
  C as comparePossiblyUndefined,
  Mt as comparePropsEqual,
  mt as createSpan,
  _t as createSpanName,
  ut as debug,
  Vt as encodeObjectProperties,
  Gt as error,
  ot as getConfig,
  $ as getCurrentSpan,
  N as getTracer,
  Dt as info,
  Wt as initializeTracing,
  Rt as instrument,
  kt as instrumentService,
  ne as isApiError,
  oe as isApiErrorLike,
  T as log,
  lt as logHttpErrorResponse,
  ft as logHttpRequest,
  pt as logHttpSuccessResponse,
  Ht as markSpanError,
  dt as normalizeAxiosError,
  h as stringifyAttrs,
  g as stringifyLoggable,
  st as trimBaseUrl,
  q as updateUrl,
  jt as useAutoFocus,
  Zt as useUnMounted
};
//# sourceMappingURL=index.es.js.map
